import { useMutation, useQueryClient } from '@tanstack/react-query';
import { updateOrganization } from '../../api/remiApi';

interface SoftDeleteOrganizationParams {
  orgId: string;
}

export const useSoftDeleteOrganization = (onSuccess?: () => void) => {
  const queryClient = useQueryClient();

  const softDeleteOrganization = async ({ orgId }: SoftDeleteOrganizationParams) => {
    const now = new Date().toISOString();
    await updateOrganization(orgId, {
      deleted: true,
      deleted_at: now,
      updated_at: now,
    });
  };

  const { mutate, isPending } = useMutation({
    mutationFn: softDeleteOrganization,
    onSuccess: () => {
      // Invalidate both the admin list and the organization switcher
      queryClient.invalidateQueries({ queryKey: ['Organizations'] });
      queryClient.invalidateQueries({ queryKey: ['organizationsList'] });
      onSuccess?.();
    },
  });

  return {
    softDeleteOrganization: mutate,
    isPending,
  };
};
